import { useState } from 'react';

const useForceStateUpdate = () => {
  const [, setRandomState] = useState<number | null>(null);

  const forceStateUpdate = (): void => {
    setRandomState(Math.random());
  };

  return forceStateUpdate;
};

export default useForceStateUpdate;
